export default {
  "NOTIFICATIONS": "Notifications",
  "NOTIFICATION": "Notification"
};
